import type {ReactNode} from 'react';
import {useState} from 'react';
import {OverlayTrigger, Popover} from 'react-bootstrap';

type TPopover = {
	children: ReactNode;
	classes: string;
	iconSize?: string;
};
const PopoverComponent = ({
	children,
	classes,
	iconSize = '1.4rem',
}: TPopover) => {
	const [show, setShow] = useState(false);

	const handleToggle = () => setShow(prev => !prev);

	const popoverTop = (
		<Popover id="popover-positioned-top" title="">
			<Popover.Header>
				<span onClick={handleToggle} className="close">
					×
				</span>
			</Popover.Header>
			<div className="popoverbox">{children}</div>
		</Popover>
	);

	return (
		<OverlayTrigger
			show={show}
			onToggle={handleToggle}
			trigger="click"
			placement="auto"
			overlay={popoverTop}>
			<i
				className={`bi bi-info-circle-fill text-dark ${classes}`}
				style={{fontSize: iconSize}}
				role="button"
			/>
		</OverlayTrigger>
	);
};

export default PopoverComponent;
